import { CekSenetDetayPage } from './../cek-senet-detay/cek-senet-detay';
import { CekSenetDurumDegistirPage } from './../cek-senet-durum-degistir/cek-senet-durum-degistir';
import { CekSenetEkleGuncellePage } from './../../CekSenetIslemleri/cek-senet-ekle-guncelle/cek-senet-ekle-guncelle';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

@Component({
  selector: 'page-cek-senet-liste',
  templateUrl: 'cek-senet-liste.html',
})
export class CekSenetListePage {
  sayfaadi = "";
  GelenListe = [];
  aranan = "";
  aranacaksayfa: number = 0;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public modalCtrl: ModalController,
    public ortak: Ortak,
    public actionSheetCtrl: ActionSheetController,
    public navParams: NavParams) {
    if (navParams.get("page") != null) {
      this.sayfaadi = navParams.get("page");
      if (this.sayfaadi == "Müşteri Çeki") {
        this.aranacaksayfa = 1;
      }
      if (this.sayfaadi == "Müşteri Seneti") {
        this.aranacaksayfa = 2;
      }
      if (this.sayfaadi == "Verilen Çekler") {
        this.aranacaksayfa = 3;
      }
      if (this.sayfaadi == "Verilen Senetler") {
        this.aranacaksayfa = 4;
      }
      if (this.sayfaadi == "Vadesi Yaklaşan Çekler") {
        this.aranacaksayfa = 5;
      }
      if (this.sayfaadi == "Vadesi Geçen Çekler") {
        this.aranacaksayfa = 6;
      }
      if (this.sayfaadi == "Vadesi Yaklaşan Senetler") {
        this.aranacaksayfa = 7;
      }
      if (this.sayfaadi == "Vadesi Geçen Senetler") {
        this.aranacaksayfa = 8;
      }

    }
  }

  ionViewDidLoad() {
    this.VerileriGetir();
  }
  VerileriGetir() {
    var formdata = new FormData();
    formdata.append("aranan", this.aranan);
    formdata.append("istenenliste", this.aranacaksayfa.toString());
    this.bllOrtak.islem(formdata, "CekSenetGetir", "Lütfen Bekleyiniz..", true).then(a => {
      var sonuc = <any>a;
      this.GelenListe = sonuc.SonucObject;
    


    });
  }
  kayitAra(e) {
    if (e.keyCode == 13) {
      this.VerileriGetir();
    }
  }
  YeniEkle() {
    let modal = this.modalCtrl.create(CekSenetEkleGuncellePage, { tip: this.aranacaksayfa });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    })
    modal.present();
  }
  Guncelle(item) {
    let modal = this.modalCtrl.create(CekSenetEkleGuncellePage, { items: item });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    })
    modal.present();
  }
  DetaylariGoster(item)
  {
    let modal = this.modalCtrl.create(CekSenetDetayPage, { item: item });
    modal.onDidDismiss(data => {

    })
    modal.present();
  }
  DurumDegistir(item) {
    if(item.SonDurum!=1&&item.SonDurum!=7)
    {
      this.ortak.showBasicAlert("Uyarı","Bu kaydın Durumu Değiştirilemez!!");
    }
    else
    {
      let modal = this.modalCtrl.create(CekSenetDurumDegistirPage, { items: item });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      })
      modal.present();
    }
  
  }
KayitSil(item)
{
  if(item.SonDurum==2||item.SonDurum==8)
  {
    this.ortak.showBasicAlert("Hata","Bu kayıt silinemez..")
  }
  else
  {
    this.ortak.showConfirmAlert("Uyarı","Kayıt Silinecek Onaylıyormusunuz?").then(a=>{
      var formdata=new FormData();
      formdata.append("itemid",item.ID.toString());
      this.bllOrtak.islem(formdata,"CekSenetSil","",false).then(a=>{
        var sonuc=<any>a;
        if(sonuc.Sonuc==1)
        {
          this.ortak.showBasicAlert("Başarılı","Kayıt başarılı bir şekilde silimiştir");
          this.VerileriGetir();
        }
       
        if(sonuc.Sonuc!=1)this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
      })
    })
  }

}
  Islemler(item) {
    const actionSheet = this.actionSheetCtrl.create({
      title: item.CariAdi,
      buttons: [
        {
          text: 'Sil ',

          handler: () => {
this.KayitSil(item);
          }

        },
        {
          text: 'Detaylar',

          handler: () => {
this.DetaylariGoster(item);
          }

        },

        {
          text: 'Durum Değiştir',

          handler: () => {
            this.DurumDegistir(item);
          }

        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/CekSenetIslemleri/cek-senet-liste/cek-senet-liste.ts